import { React, DomeComponent } from "@lexriver/dome";
import css from './ProductChosenAttributes.m.scss'
import { DataTypes } from "@lexriver/data-types";


interface Attrs{
    attributes?:Object
}
export class ProductChosenAttributes extends DomeComponent<Attrs>{
    render(){
        if(!this.attrs.attributes) return <></>
        if(DataTypes.isObjectWithKeys(this.attrs.attributes) == false) return <></>
        if(Object.keys(this.attrs.attributes).length ==0) return <></>
        let result:HTMLDivElement = <div class={css.chosenAttributes}></div>
        for(let key of Object.keys(this.attrs.attributes)){
            result.appendChild(<div>{key}: {this.attrs.attributes[key]}</div>)
        }
        return result
    
    }
}